import React, { useEffect, useState } from "react";
import http from "../../../Utils/axiosConfig";
import { apiMessage } from "../../../Utils/apiMessage";
import ToastService from "../../../Utils/ToastService";
import "./Details.css";

const PAGE_SIZE = 10;

const Account = ({ mem_id }) => {
  const [accountData, setAccountData] = useState({
    records: [],
    balance: 0,
    total: 0,
  });
  const [formData, setFormData] = useState({ advance: "" });
  const [page, setPage] = useState(1);

  const fetchData = async (pageNum = 1) => {
    try {
      const response = await http.post("account/get_advance", {
        mem_id,
        page: pageNum,
        limit: PAGE_SIZE,
      });
      if (response.code === "DATA_FOUND") {
        setAccountData(response.data || { records: [], balance: 0, total: 0 });
      }
    } catch (error) {
      console.error("Error fetching:", error);
    }
  };

  useEffect(() => {
    fetchData(page);
  }, [page]);

  const onlyNumber = (e, isDec = true) => {
    const blockedKeys = ["e", "E", "+", "-"];
    if (!isDec) blockedKeys.push(".");
    if (blockedKeys.includes(e.key)) e.preventDefault();
  };

  const onFormSubmit = async () => {
    if (!formData.advance) return;

    const now = new Date();
    const istOffset = 5.5 * 60;
    const localOffset = now.getTimezoneOffset();
    const istDate = new Date(now.getTime() + (istOffset + localOffset) * 60000);
    const today = istDate.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const [day, month, year] = today.split("/");
    const formattedDate = `${year}-${month}-${day}`;

    try {
      const response = await http.post("account/post_advance", {
        mem_id,
        date: formattedDate,
        credit: formData.advance,
      });
      if (response.code === "DETAILS_POSTED" || response.status === 200) {
        ToastService.success("माहिती जतन झाली ✅");
        setFormData({ advance: "" });
        setPage(1);
        await fetchData(1);
      }
    } catch (error) {
      console.error("Error submitting:", error);
      ToastService.error(apiMessage());
    }
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const totalPages = Math.ceil((accountData.total || 0) / PAGE_SIZE);

  return (
    <div className="account-container">
      <div className="adv-form-section">
        <label className="dre-field-label">रक्कम</label>
        <input
          type="number"
          className="dre-input"
          value={formData.advance}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, advance: e.target.value }))
          }
          onKeyDown={(e) => onlyNumber(e, true)}
          min={1}
          placeholder="0"
        />
        <button
          className="dre-submit-btn"
          disabled={!formData.advance}
          onClick={onFormSubmit}
        >
          OKAY
        </button>
      </div>

      <div className="balance-bar">
        <span>एकूण शिल्लक:</span>
        <span className="balance-amount">Rs. {accountData?.balance ?? 0}</span>
      </div>

      <div className="table-container">
        {accountData?.records?.length > 0 ? (
          <>
            <div className="table-wrapper">
              <table className="emc-table adv-table">
                <thead>
                  <tr>
                    <th>तारीख</th>
                    <th>रक्कम</th>
                    <th>कपात</th>
                  </tr>
                </thead>
                <tbody>
                  {accountData.records.map((record, index) => (
                    <tr key={index}>
                      <td>{formatDate(record.date)}</td>
                      <td>{record.credit || "-"}</td>
                      <td>{record.debit || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {totalPages > 1 && (
              <div className="pagination">
                <button
                  className="page-btn"
                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                  disabled={page === 1}
                >
                  &#8249;
                </button>
                <span className="page-info">
                  {page} / {totalPages}
                </span>
                <button
                  className="page-btn"
                  onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                  disabled={page === totalPages}
                >
                  &#8250;
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="no-data">
            <p>कोणतेही रेकॉर्ड आढळले नाही.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Account;
